// eslint-disable-next-line no-unused-vars
import { CareerAndSeasonStatsState } from '../types';
import '../../types';

/**
 * @param {CareerAndSeasonStatsState} draft - Draft state.
 * @param {object} payload - Action payload.
 * @param payload.seasonId
 * @param payload.roundStats
 */
export const setCareerSeasonsStats = (draft, { seasonId, roundStats }) => {
    draft.data.season = {
        ...draft.data.season,
        [seasonId]: [...roundStats]
    };
};
